import { render, staticRenderFns } from "./AutomatorDocsTemplateList.vue?vue&type=template&id=a3645a5c&scoped=true"
import script from "./AutomatorDocsTemplateList.vue?vue&type=script&lang=js"
export * from "./AutomatorDocsTemplateList.vue?vue&type=script&lang=js"
import style0 from "./AutomatorDocsTemplateList.vue?vue&type=style&index=0&id=a3645a5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3645a5c",
  null
  
)

export default component.exports